import { useSelector, useDispatch } from "react-redux";
import { useCallback, useEffect, useState } from "react";
import LeaderOrder from "./LeadrOrder";
import navOperations from 'redux/Navigation/operations';
import { setActiveHeader} from 'redux/MyOrder/action';
import pendingOrderOperations from 'redux/PendingOrder/operations'
import RejectedBee from "../../../../assets/images/PenndingApproval/Rejected Bee.png";
import userProfileSelectors from 'redux/UserProfile/selectors'
import pendingOrderSelectors from "redux/PendingOrder/selectors";
import selectors from "redux/Navigation/selectors";
import Moment from 'moment';
import { useNavigate, useParams } from "react-router-dom";
import { setIsOrderCanceled } from "redux/PendingOrder/action";
import RequisitionAction from 'Store/Component/Requisition/RequisitionAction'
import { CONSTANTS } from "client/utils/constants";
import TransferAction from "Store/Component/Transfer/TransferAction";
import { expenditureColumn } from "client/utils/ExpenditureColumn";

const LeadrOrderContainer = (props: any) => {
  const { isBulkOrder = false } = props
  const activeRow = useSelector((state: any) => state.CustomerMyOrder.data)
  const { orderByIdValue, userDetails, headerNav, expenditureData}: any = useSelector((state: any) => ({
    orderByIdValue: state.OrderReducer.orderByIdData,
    userDetails: userProfileSelectors.getUserDetails(state),
    headerNav: selectors.GetHeaderNav(state),
    expenditureData: pendingOrderSelectors.getExpenditure(state),
  }));
  const dispatch = useDispatch();  
  const cancelOrderRequest = pendingOrderOperations.dispatchCancelOrderRequest(dispatch);
  const dispatchNav = navOperations.dispatchNav(dispatch)  
  const dispatchActionPopupValue = pendingOrderOperations.dispatchActionPopup(dispatch);
  const getExpenditure = pendingOrderOperations.getExpenditureDetail(dispatch);  
  const [headerNavItem, setHeaderNavItem] = useState("home");  

  useEffect(() => {
    getExpenditure({ id: 1 });
  }, []);

  const isOrderCanceled = useSelector(
    (state: any) => state.PendingOrder.isOrderCanceled
  );  
  const actionPopupValue = useSelector(
    (state: any) => state.PendingOrder.actionPopupValue
  );
  const [approvalAction, setApprovalAction] = useState<any>({
    actionby: "",
    cancelorderFailed: ""
  });
   
  const navigate = useNavigate();
  let { pagename } = useParams();

  const handleClickOrder = (item: any) => {
    dispatch(RequisitionAction.setIsEditRequestClick(false))
    dispatch(RequisitionAction.setEditRequestDetails({}))
    dispatch(RequisitionAction.setIsChangesOccured(false));
    dispatch(TransferAction.setIsChangesOccuredInCart(false))
    dispatch(RequisitionAction.setIsEditOrder(true))
    if(isBulkOrder){
      navigate('/ordermanagement/createnewbulkorder/' + orderByIdValue.orderId + '/home');
    } else {
      navigate('/ordermanagement/createorder/'+ orderByIdValue.orderId +'/orderDetails');
    }
    dispatch(setIsOrderCanceled(""));
  }

  const [Popupcontent, setPopupcontent] = useState<any>({
    title: "",
    isDialogVisible: false,
    isTitleWarning: false,
    subtextcontent: "",
    primaryBtnText: "",
    outlineBtnText: "",
    isSingleConfirmationBtn: false,
    isCommentboxVisible: false,
    isCompletedReportVisible: false,
    titleImg: "",
    isCommentBoxRequire: false,
    outlineBtnnavigateTo: "",
    primaryBtnnavigateTo: "",
    actionby: "",
    value: 0,
    comment: "",
  });

  const cancelOrderReq = (cancelOrdersubtext: any) => {
    setPopupcontent({
      ...Popupcontent,
      titleImg: RejectedBee,
      title: "CANCEL ORDER",
      isDialogVisible: true,
      isTitleWarning: false,
      subtextcontent: cancelOrdersubtext,
      primaryBtnText: "Yes",
      outlineBtnText: "No",
      isSingleConfirmationBtn: false,
      isCommentboxVisible: true,
      isCommentBoxRequire: true,
      isCompletedReportVisible: false,
      outlineBtnnavigateTo: "",
      primaryBtnnavigateTo: (headerNavItem === "Customer My Orders") ? "Customer My Orders" : headerNavItem,
      actionby: "CancelOrderBtn",
      href: "/ordermanagement",
    });
    dispatch(setActiveHeader(CONSTANTS.ACTIVE_HEADER.HOME))
  };

  useEffect(() => {
    setHeaderNavItem(headerNav);
  }, [headerNav]);

  const getPopupContent = (
    titleImg: string,
    actionby: string,
    subtextcontent: any,
    titleText: string,
    isCompletedReportVisible: any
  ) => {
    return {
      ...Popupcontent,
      titleImg,
      actionby,
      subtextcontent,
      title: titleText,
      isCompletedReportVisible,
      isDialogVisible: true,
      isTitleWarning: false,
      primaryBtnText: "",
      outlineBtnText: "Close",
      isSingleConfirmationBtn: true,
      isCommentboxVisible: false,
      isCommentBoxRequire: false, 
      outlineBtnnavigateTo: (headerNavItem === "Customer My Orders") ? "Customer My Orders" : headerNavItem,
      primaryBtnnavigateTo: "",
    };
  };

  
  const hideDialog = useCallback(
    () => setPopupcontent({ ...Popupcontent, isDialogVisible: false }),
    [Popupcontent]
  );

  const popupOutlinebtnOnclick = (item: any) => {
    if (item !== "") {
      dispatchNav(item);
      navigate('/ordermanagement')
    }
    if (actionPopupValue.actionby === "CancelOrderBtn") {
      dispatchActionPopupValue({})
      isOrderCanceled.approval = undefined;
      if(pagename === CONSTANTS.PAGE_NAME.REQUISITION){
        dispatchNav('Customer My Orders')
      }else if(pagename == "Bulk Order"){
        dispatchNav('Bulk Orders')
      }else{
        dispatchNav('Home')
      }
      navigate('/ordermanagement');
    }
    hideDialog();
  };

  const popupPrimarybtnOnclick = (
    item: any,
    comment: string,
    actionby: string,
    value: any
  ) => {
    cancelOrderRequest({ orderId: orderByIdValue?.orderId, savedBy: userDetails?.emailId, comments: comment });
    dispatchActionPopupValue({
      actionby: actionby
    })
    hideDialog();
  };

  useEffect(() => {
    if (isOrderCanceled.approval) {
      dispatch(RequisitionAction.setIsChangesOccured(false))
      let cancelorder = "Order Cancelled Successfully"
      setApprovalAction({
        ...approvalAction,
        actionby: actionPopupValue.actionby,
        cancelorder
      });
    }
    else {
      let cancelorder = "Order Cancelled Failed"
      setApprovalAction({
        ...approvalAction,
        actionby: actionPopupValue.actionby,
        cancelorder
      });
    }
  }, [activeRow?.rowData, isOrderCanceled?.approval])

  useEffect(() => {
    if (approvalAction.actionby === "CancelOrderBtn") {
      setPopupcontent({
        ...getPopupContent(
          RejectedBee,
          "Order Cancelled Successfully",
          "Order Cancelled Successfully",
          "Success",
          false
        ),
      });
    }
  }, [approvalAction]);         

    let setValue = 0;
        if(userDetails?.role === 'Fleet Admin') {       
            orderByIdValue?.requests?.map((item: any) => {        
                if(item?.itemStatus === 'Approved'){
                    setValue = 1;
                }
                else {
                     setValue = 0;
                } 
          })    
    }

    const [collapse, setCollapse] = useState(false);
    const onExpand = () => {
        setCollapse(!collapse)
    }
    
    const createdDateval = () => {
      if(orderByIdValue?.hasOwnProperty('createdDate')){
          if(orderByIdValue?.createdDate){
               return( Moment(orderByIdValue?.createdDate).format('MM/DD/YYYY'))
           }else{return('')}
      }
      else if(orderByIdValue?.hasOwnProperty('orderDate')){
          if(orderByIdValue?.orderDate){
              return( Moment(orderByIdValue?.orderDate).format('MM/DD/YYYY'))
          }else{return('')}
      }
  }

   const getUserRoles = () => {
    let roles = userDetails?.roles?.map((role: any) => role.roleName)
    return roles
  }

  return (
    <LeaderOrder
      orderByIdValue={orderByIdValue}
      handleClickOrder={handleClickOrder}
      cancelOrderReq={cancelOrderReq}
      Popupcontent={Popupcontent}
      hideDialog={hideDialog}
      createdDateval={createdDateval}
      popupOutlinebtnOnclick={popupOutlinebtnOnclick}
      popupPrimarybtnOnclick={popupPrimarybtnOnclick} 
      collapse={collapse}
      onExpand={onExpand}
      expenditureData={expenditureData}
      userDetails={userDetails}
      expenditureColumn={expenditureColumn} 
      activeRow={activeRow}
      setValue={setValue}
      isBulkOrder={isBulkOrder}
      getUserRoles={getUserRoles}
      />
    )
}

export default LeadrOrderContainer;